/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */

export type BookingDtoBookingType = typeof BookingDtoBookingType[keyof typeof BookingDtoBookingType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BookingDtoBookingType = {
  STANDARD: 'STANDARD',
  SYNTHETIC: 'SYNTHETIC',
  EXPRESS: 'EXPRESS',
  UNKNOWN: 'UNKNOWN',
} as const;
